export class Keyboard {
  private down: Set<string> = new Set();

  constructor() {
    window.addEventListener("keydown", (e) => {
      this.down.add(e.code);
    });
    window.addEventListener("keyup", (e) => {
      this.down.delete(e.code);
    });
    window.addEventListener("blur", () => {
      this.down.clear();
    });
  }

  isDown(code: string): boolean {
    return this.down.has(code);
  }
}
